module.exports = __webpack_public_path__ + "media/images/flags/LC-5dcfb0366453ad1b7b2e7635d85658ab.svg";